import React from 'react';
import { useTranslation } from '@/app/components/translations/Translation.tsx';
import CloseIcon from '../../../../Modal/CloseIcon';
import { PromoContainer } from './styled.tsx';

type Props = {
  handlePromoMessage: (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
};

const PromoTooltip = ({ handlePromoMessage }: Props) => {
  const { t } = useTranslation();
  return (
    <PromoContainer onClick={handlePromoMessage}>
      <CloseIcon />
      <h2>{t('vacation.oss.comparison.tooltip.promo_title')}</h2>
      <p>{t('vacation.oss.comparison.tooltip.promo_description')}</p>
    </PromoContainer>
  );
};

export default PromoTooltip;
